import type { Lead } from '@up2stay/up2promo-api-client';

export type EventNameRef = {
  id?: string | null;
  _id?: string | null;
  name?: string | null;
};

export function eventRefId(event: EventNameRef | null | undefined): string {
  return String(event?.id ?? event?._id ?? '').trim();
}

export function eventNamesFromLead(
  lead: Lead | null | undefined,
): Record<string, string> {
  const extra = lead as
    | (Lead & { eventNames?: Record<string, string> | null })
    | null
    | undefined;
  const raw = extra?.eventNames;
  if (!raw || typeof raw !== 'object') return {};
  const names: Record<string, string> = {};
  for (const [key, value] of Object.entries(raw)) {
    const id = key.trim();
    const name = String(value ?? '').trim();
    if (id && name) names[id] = name;
  }
  return names;
}

export function buildEventNameMap(
  events: ReadonlyArray<EventNameRef> = [],
  extraNames?: Record<string, string> | null,
): Map<string, string> {
  const map = new Map<string, string>();
  const index = (id: string, name: string) => {
    map.set(id, name);
    const lower = id.toLowerCase();
    if (lower !== id) map.set(lower, name);
  };
  if (extraNames) {
    for (const [key, value] of Object.entries(extraNames)) {
      const id = key.trim();
      const name = value.trim();
      if (id && name) index(id, name);
    }
  }
  for (const event of events) {
    const id = eventRefId(event);
    const name = event.name?.trim();
    if (id && name) index(id, name);
  }
  return map;
}

export function resolveEventDisplayName(
  eventId: string | null | undefined,
  nameById: ReadonlyMap<string, string>,
  options?: { storedName?: string | null; fallbackToId?: boolean },
): string {
  const stored = options?.storedName?.trim();
  if (stored) return stored;
  const id = (eventId ?? '').trim();
  if (!id) return options?.fallbackToId === false ? '' : '—';
  const name =
    nameById.get(id)?.trim() || nameById.get(id.toLowerCase())?.trim();
  if (name) return name;
  if (options?.fallbackToId === false) return '';
  return id;
}
